import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            wallet {
              id
              balance
            }
          }
        }
      }
    `,
  },
  update: {
    name: "updateWallet",
    serviceName: "admin",
    query: gql`
      mutation updateWallet($ids: [String]!, $balance: String) {
        updateWallet(ids: $ids, balance: $balance) {
          messages
          influenced_count
          total_amount_added
        }
      }
    `,
  },
};

export default schema;
